export const UserImageAvatar = '/placeholder-avatar.png';

export const COUNTRIES_LIST = [
  { "country": "Afghanistan" },
  { "country": "Aland Islands" },
  { "country": "Albania" },
  { "country": "Algeria" },
  { "country": "American Samoa" },
  { "country": "Andorra" },
  { "country": "Angola" },
  { "country": "Anguilla" },
  { "country": "Antarctica" },
  { "country": "Antigua And Barbuda" },
  { "country": "Argentina" },
  { "country": "Armenia" },
  { "country": "Aruba" },
  { "country": "Australia" },
  { "country": "Austria" },
  { "country": "Azerbaijan" },
  { "country": "Bahamas" },
  { "country": "Bahrain" },
  { "country": "Bangladesh" },
  { "country": "Barbados" },
  { "country": "Belarus" },
  { "country": "Belgium" },
  { "country": "Belize" },
  { "country": "Benin" },
  { "country": "Bermuda" },
  { "country": "Bhutan" },
  { "country": "Bolivia" },
  { "country": "Bosnia And Herzegovina" },
  { "country": "Botswana" },
  { "country": "Bouvet Island" },
  { "country": "Brazil" },
  { "country": "British Indian Ocean Territory" },
  { "country": "Brunei Darussalam" },
  { "country": "Bulgaria" },
  { "country": "Burkina Faso" },
  { "country": "Burundi" },
  { "country": "Cambodia" },
  { "country": "Cameroon" },
  { "country": "Canada" },
  { "country": "Cape Verde" },
  { "country": "Cayman Islands" },
  { "country": "Central African Republic" },
  { "country": "Chad" },
  { "country": "Chile" },
  { "country": "China" },
  { "country": "Christmas Island" },
  { "country": "Cocos (Keeling) Islands" },
  { "country": "Colombia" },
  { "country": "Comoros" },
  { "country": "Congo" },
  { "country": "Congo, Democratic Republic" },
  { "country": "Cook Islands" },
  { "country": "Costa Rica" },
  { "country": "Cote D'Ivoire" },
  { "country": "Croatia" },
  { "country": "Cuba" },
  { "country": "Cyprus" },
  { "country": "Czech Republic" },
  { "country": "Denmark" },
  { "country": "Djibouti" },
  { "country": "Dominica" },
  { "country": "Dominican Republic" },
  { "country": "Ecuador" },
  { "country": "Egypt" },
  { "country": "El Salvador" },
  { "country": "Equatorial Guinea" },
  { "country": "Eritrea" },
  { "country": "Estonia" },
  { "country": "Ethiopia" },
  { "country": "Falkland Islands" },
  { "country": "Faroe Islands" },
  { "country": "Fiji" },
  { "country": "Finland" },
  { "country": "France" },
  { "country": "French Guiana" },
  { "country": "French Polynesia" },
  { "country": "French Southern Territories" },
  { "country": "Gabon" },
  { "country": "Gambia" },
  { "country": "Georgia" },
  { "country": "Germany" },
  { "country": "Ghana" },
  { "country": "Gibraltar" },
  { "country": "Greece" },
  { "country": "Greenland" },
  { "country": "Grenada" },
  { "country": "Guadeloupe" },
  { "country": "Guam" },
  { "country": "Guatemala" },
  { "country": "Guernsey" },
  { "country": "Guinea" },
  { "country": "Guinea-Bissau" },
  { "country": "Guyana" },
  { "country": "Haiti" },
  { "country": "Heard Island & Mcdonald Islands" },
  { "country": "Holy See (Vatican City State)" },
  { "country": "Honduras" },
  { "country": "Hong Kong" },
  { "country": "Hungary" },
  { "country": "Iceland" },
  { "country": "India" },
  { "country": "Indonesia" },
  { "country": "Iran, Islamic Republic Of" },
  { "country": "Iraq" },
  { "country": "Ireland" },
  { "country": "Isle Of Man" },
  { "country": "Israel" },
  { "country": "Italy" },
  { "country": "Jamaica" },
  { "country": "Japan" },
  { "country": "Jersey" },
  { "country": "Jordan" },
  { "country": "Kazakhstan" },
  { "country": "Kenya" },
  { "country": "Kiribati" },
  { "country": "Korea" },
  { "country": "Kuwait" },
  { "country": "Kyrgyzstan" },
  { "country": "Lao People's Democratic Republic" },
  { "country": "Latvia" },
  { "country": "Lebanon" },
  { "country": "Lesotho" },
  { "country": "Liberia" },
  { "country": "Libyan Arab Jamahiriya" },
  { "country": "Liechtenstein" },
  { "country": "Lithuania" },
  { "country": "Luxembourg" },
  { "country": "Macao" },
  { "country": "Macedonia" },
  { "country": "Madagascar" },
  { "country": "Malawi" },
  { "country": "Malaysia" },
  { "country": "Maldives" },
  { "country": "Mali" },
  { "country": "Malta" },
  { "country": "Marshall Islands" },
  { "country": "Martinique" },
  { "country": "Mauritania" },
  { "country": "Mauritius" },
  { "country": "Mayotte" },
  { "country": "Mexico" },
  { "country": "Micronesia, Federated States Of" },
  { "country": "Moldova" },
  { "country": "Monaco" },
  { "country": "Mongolia" },
  { "country": "Montenegro" },
  { "country": "Montserrat" },
  { "country": "Morocco" },
  { "country": "Mozambique" },
  { "country": "Myanmar" },
  { "country": "Namibia" },
  { "country": "Nauru" },
  { "country": "Nepal" },
  { "country": "Netherlands" },
  { "country": "Netherlands Antilles" },
  { "country": "New Caledonia" },
  { "country": "New Zealand" },
  { "country": "Nicaragua" },
  { "country": "Niger" },
  { "country": "Nigeria" },
  { "country": "Niue" },
  { "country": "Norfolk Island" },
  { "country": "Northern Mariana Islands" },
  { "country": "Norway" },
  { "country": "Oman" },
  { "country": "Pakistan" },
  { "country": "Palau" },
  { "country": "Palestinian Territory, Occupied" },
  { "country": "Panama" },
  { "country": "Papua New Guinea" },
  { "country": "Paraguay" },
  { "country": "Peru" },
  { "country": "Philippines" },
  { "country": "Pitcairn" },
  { "country": "Poland" },
  { "country": "Portugal" },
  { "country": "Puerto Rico" },
  { "country": "Qatar" },
  { "country": "Reunion" },
  { "country": "Romania" },
  { "country": "Russian Federation" },
  { "country": "Russia" },
  { "country": "Rwanda" },
  { "country": "Saint Barthelemy" },
  { "country": "Saint Helena" },
  { "country": "Saint Kitts And Nevis" },
  { "country": "Saint Lucia" },
  { "country": "Saint Martin" },
  { "country": "Saint Pierre And Miquelon" },
  { "country": "Saint Vincent And Grenadines" },
  { "country": "Samoa" },
  { "country": "San Marino" },
  { "country": "Sao Tome And Principe" },
  { "country": "Saudi Arabia" },
  { "country": "Senegal" },
  { "country": "Serbia" },
  { "country": "Seychelles" },
  { "country": "Sierra Leone" },
  { "country": "Singapore" },
  { "country": "Slovakia" },
  { "country": "Slovenia" },
  { "country": "Solomon Islands" },
  { "country": "Somalia" },
  { "country": "South Africa" },
  { "country": "South Georgia And Sandwich Isl." },
  { "country": "Spain" },
  { "country": "Sri Lanka" },
  { "country": "Sudan" },
  { "country": "Suriname" },
  { "country": "Svalbard And Jan Mayen" },
  { "country": "Swaziland" },
  { "country": "Sweden" },
  { "country": "Switzerland" },
  { "country": "Syrian Arab Republic" },
  { "country": "Taiwan" },
  { "country": "Tajikistan" },
  { "country": "Tanzania" },
  { "country": "Thailand" },
  { "country": "Timor-Leste" },
  { "country": "Togo" },
  { "country": "Tokelau" },
  { "country": "Tonga" },
  { "country": "Trinidad And Tobago" },
  { "country": "Tunisia" },
  { "country": "Turkey" },
  { "country": "Turkmenistan" },
  { "country": "Turks And Caicos Islands" },
  { "country": "Tuvalu" },
  { "country": "Uganda" },
  { "country": "Ukraine" },
  { "country": "United Arab Emirates" },
  { "country": "United Kingdom" },
  { "country": "United States" },
  { "country": "United States Outlying Islands" },
  { "country": "Uruguay" },
  { "country": "Uzbekistan" },
  { "country": "Vanuatu" },
  { "country": "Venezuela" },
  { "country": "Vietnam" },
  { "country": "Virgin Islands, British" },
  { "country": "Virgin Islands, U.S." },
  { "country": "Wallis And Futuna" },
  { "country": "Western Sahara" },
  { "country": "Yemen" },
  { "country": "Zambia" },
  { "country": "Zimbabwe" }
];

export const COUNTRIES_NAME_LIST = COUNTRIES_LIST.map((count: any) => count.country);
